import { useEffect } from 'react';
import { useDebounce } from '@fttb/common/utils';

// utils

import { composeConnectionData } from "../utils/utils";
export var useAddressVerification = function useAddressVerification(_ref) {
  var checkAddressType = _ref.checkAddressType,
    flat = _ref.flat,
    house = _ref.house,
    isConvergentRequest = _ref.isConvergentRequest,
    region = _ref.region,
    setLoading = _ref.setLoading,
    street = _ref.street,
    checkConnection = _ref.checkConnection;
  var deferredFlat = useDebounce(flat, 400);
  var handleCheckConnection = function handleCheckConnection() {
    if (!(region !== null && region !== void 0 && region.label) || !(street !== null && street !== void 0 && street.label) || !(house !== null && house !== void 0 && house.label) || !flat) {
      return;
    }
    setLoading(true);
    var connectionData = composeConnectionData({
      checkAddressType: checkAddressType,
      flat: flat,
      house: house,
      isConvergentRequest: isConvergentRequest,
      region: region,
      street: street
    });
    checkConnection(connectionData);
  };
  useEffect(function () {
    handleCheckConnection();
  }, [deferredFlat]);
};